var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgentz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_78)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.875 9.04878L1.54878 9.5061V9.5061C1.33834 9.57624 1.14475 9.36307 1.23479 9.16035L2.3555 6.6368C2.42999 6.46905 2.4725 6.28885 2.48082 6.10549L2.52287 5.17888C2.60424 3.38564 3.7722 1.82385 5.46931 1.23891V1.23891C5.92823 1.08074 6.41026 1 6.89567 1H14.1008C14.4053 1 14.7019 1.09645 14.9482 1.27551V1.27551",
    stroke: "#EB2187",
    strokeWidth: 0.914634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10515 3.1723L12.7073 3.19517M7.79112 4.58998L13.3933 4.61285",
    stroke: "#4FC7E9",
    strokeWidth: 0.54878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08233 3.19507L12.7048 3.23862M7.08232 5.85186L12.7048 5.89542",
    stroke: "#4FC7E9",
    strokeWidth: 0.54878
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.971 1.29732C15.054 1.21433 14.9864 10.2235 14.9731 11.8939C14.9718 12.0581 14.8826 12.2081 14.7393 12.2883L14.3806 12.4891C14.3178 12.5242 14.2475 12.544 14.1756 12.5469L14.0669 12.5513C13.8103 12.5617 13.6126 12.7812 13.629 13.0375L13.7811 15.4139C13.7817 15.4236 13.7831 15.4331 13.7854 15.4425V15.4425C13.8246 15.6061 13.6264 15.72 13.5048 15.6037L10.5 12.7297C10.4118 12.6453 10.2935 12.5997 10.1715 12.603L3.38515 12.7875C3.14819 12.7939 2.94559 12.6182 2.91842 12.3827L2.76064 11.0153L2.62344 9.11744",
    stroke: "#EB2187",
    strokeWidth: 0.914634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.07321 9.10407C2.96644 9.07158 2.93079 9.06542 2.83513 8.93382C2.73948 8.80221 2.69205 8.66 2.71492 8.61427C2.83106 8.6556 2.91601 8.70853 3.00156 8.84866C3.10364 9.07158 3.08077 9.09445 3.07321 9.10407Z",
    fill: "#EB2187"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.89788,
    cy: 9.04863,
    rx: 0.160061,
    ry: 0.137195,
    fill: "#EB2187"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6737,
    y: 1.22864,
    width: 0.640244,
    height: 0.594512,
    fill: "#EB2187"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentz);
export default __webpack_public_path__ + "static/media/agentz.bca3727600a296d2bffb21db27d1af68.svg";
export { ForwardRef as ReactComponent };